module.exports = __webpack_public_path__ + "static/media/up_arrow.33bc9955.svg";